import { RootState } from '@/store/store'
import { ArtifactVersionRead } from '../schemas'

/**
 * Select: Artifact by ID
 *
 * Returns the artifact with the given id, or null if it does not exist.
 */
export const selectArtifactById = (state: RootState, props: { artifactVersionId: string | undefined | null }): ArtifactVersionRead | null => {
  const { artifactVersionId } = props
  if (!artifactVersionId) return null

  return state.artifactsState.artifactsVersions[artifactVersionId] ?? null
}

/**
 * Select: turn_id of the agent turn that produced an artifact version, or null if unknown.
 *
 * Returns the artifact version's turn_id, or null for versions ingested without a known turn association.
 */
export const selectTurnIdForArtifactVersion = (state: RootState, props: { artifactVersionId: string }): string | null => {
  return state.artifactsState.turnIdByArtifactVersionId[props.artifactVersionId] ?? null
}
